import { FC } from 'react'

export const GtmNoscript: FC<{ gtmId: string }> = ({ gtmId }) => {
  if (!gtmId) {
    console.error('Google Tag Manager ID is missing!')
    return null
  }

  return (
    <noscript>
      <iframe
        src={`https://www.googletagmanager.com/ns.html?id=${gtmId}`}
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
      ></iframe>
    </noscript>
  )
}
